import React from 'react';
import { MapContainer as MapContainerLeaflet, TileLayer } from 'react-leaflet';
import { Helmet } from 'react-helmet';
import L from 'leaflet';
import { isEmpty, isError, attempt } from 'lodash';

// It's more or less the center between Belgium and France
const DEFAULT_MAP_BOUND = [
  [51.5018, -4.466205],
  [41.552768, 9.655916],
];
const boundsOptions = { padding: [50, 50] };
const isJSON = (str: any) => !isError(attempt(JSON.parse, str));

function MapContainer({ children, bounds, center, zoom = 15, onClick, geojson, ...props }: any) {
  let boundsOrCenter;
  let geojsonBounds;

  if (geojson !== null && isJSON(geojson)) {
    const features = L.geoJson(JSON.parse(geojson)?.features);

    geojsonBounds = features?.getBounds();
  }

  if (center && !isEmpty(center) && !isEmpty(center[0]) && !isEmpty(center[1])) {
    if (geojsonBounds) {
      boundsOrCenter = {
        boundsOptions,
        bounds: L.latLngBounds([center]).extend(geojsonBounds),
      };
    } else {
      boundsOrCenter = {
        center,
        zoom,
      };
    }
  } else if (bounds && geojsonBounds) {
    boundsOrCenter = {
      boundsOptions,
      bounds: L.latLngBounds(bounds).extend(geojsonBounds),
    };
  } else if (bounds || geojsonBounds) {
    boundsOrCenter = {
      boundsOptions,
      bounds: bounds ? L.latLngBounds(bounds) : geojsonBounds,
    };
  } else {
    boundsOrCenter = {
      boundsOptions,
      bounds: DEFAULT_MAP_BOUND,
    };
  }

  return (
    <>
      <Helmet>
        <link
          rel="stylesheet"
          href="https://unpkg.com/leaflet@1.6.0/dist/leaflet.css"
          integrity="sha512-xwE/Az9zrjBIphAcBb3F6JVqxf46+CDLwfLMHloNu6KEQCAWi6HcDUbeOfBIptF7tcCzusKFjFw2yuvEpDL9wQ=="
          crossOrigin
        />
      </Helmet>

      <MapContainerLeaflet
        {...boundsOrCenter}
        whenCreated={(map: any) => {
          if (onClick) {
            map.on('click', (event: any) => onClick(event, map));
          }
        }}
        {...props}
      >
        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {children}
      </MapContainerLeaflet>
    </>
  );
}

export default MapContainer;
